module.exports = __webpack_public_path__ + "static/media/2_avatar.9934b29f.png";